import React, { Component } from 'react';
import ResourceForm from './ResourceForm';
import { Row, Col, Collapse } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountUp } from '@fortawesome/free-solid-svg-icons';
import ResourceContributionForm from './ResourceContributionForm';
import { Link } from 'react-router-dom';

class ResourceItem extends Component {
    render() {
        if (!this.props.edit) {
            return (
                <div>
                <Row>
                    <Col md={2}>
                        <Link to={"/officer/resources/" + this.props.resource.slug}><h5>{this.props.resource.title}</h5></Link>
                    </Col>
                    <Col md={2}>
                        <FontAwesomeIcon className="text-primary" size="sm" icon={faSortAmountUp} fixedWidth /> {this.props.resource.amount}
                    </Col>
                </Row>
                <Collapse in={this.props.add}>
                    <Row>
                        <ResourceContributionForm form={this.props.resource.slug + '-ResourceContributionForm'} addToggle={this.props.addToggle} onSubmit={this.props.contributionSubmit} initialValues={{dkp:0, slug: this.props.resource.slug, chapter:this.props.chapter, section: this.props.resource.section}} new={true} />
                    </Row>
                </Collapse>
                </div>
            )
        } else {
            return (
                <ResourceForm form={this.props.resource.slug + '-EditResourceForm'} editToggle={this.props.editToggle} onSubmit={this.props.onSubmit} initialValues={{title: this.props.resource.title, category: this.props.resource.category, dkp: this.props.resource.dkp, slug: this.props.resource.slug, chapter:this.props.chapter, section: this.props.resource.section, amount: this.props.resource.amount}} new={false} />
            )
        }
    }
}

export default ResourceItem;


// WEBPACK FOOTER //
// ./src/Officer/ResourceItem.js